import React from 'react';
import {Snackbar, Alert} from '@mui/material';
import {useSelector} from 'react-redux';
import {useDispatch} from 'react-redux';
import {hideToast} from '../actions';

const Toasts = () => {
  const dispatch = useDispatch();
  const {open, type, message} = useSelector(s => s.toasts);

  const onClose = () => dispatch(hideToast());

  return (
    <Snackbar
      open={open}
      autoHideDuration={6000}
      onClose={onClose}
      anchorOrigin={{vertical: 'bottom', horizontal: 'center'}}>
      <Alert
        severity={type}
        variant="filled"
        onClose={onClose}
        sx={{padding: '10px 32px'}}>
        {message}
      </Alert>
    </Snackbar>
  );
};

export default Toasts;
